import { RestRequest, RestContext, ResponseFunction } from 'msw'
import {
  addToEntityListData,
  updateEntityListData,
  deleteEntityListData,
} from '../../modules/mockDataCommon'
import { requireAuthenticatedUser } from '../../decorators'
import { getFieldSetListData, getFieldSetOverviewData } from './mockData'
import type { THrid } from '~/types/models'
import type { IFieldSet, IFieldSetOverview } from '~/types/fieldSet/models'

interface GetFieldSetListResponse {
  data: IFieldSet[]
}

async function getList(
  req: RestRequest,
  res: ResponseFunction,
  ctx: RestContext
) {
  console.log(`Returning fieldSets list`)
  const responseBody: GetFieldSetListResponse = {
    data: await getFieldSetListData(),
  }
  return res(ctx.status(200), ctx.json(responseBody))
}

interface GetFieldSetOverviewResponse {
  data: IFieldSetOverview
}

const getFieldSetOverviewById = async (
  req: RestRequest,
  res: ResponseFunction,
  ctx: RestContext
) => {
  const { id } = req.params
  if (typeof id !== 'string') {
    const responseBody = {
      statusCode: 500,
      message: 'Passed ID is not a string.',
    }
    return res(ctx.status(500), ctx.json(responseBody))
  }
  try {
    const responseBody: GetFieldSetOverviewResponse = {
      data: await getFieldSetOverviewData(id)!, // will either be valid or will have thrown error
    }
    return res(ctx.status(200), ctx.json(responseBody))
  } catch (e) {
    const responseBody = {
      statusCode: 404,
      message: `Unable to retrieve fieldSet overview for '${id}'`,
    }
    return res(ctx.status(404), ctx.json(responseBody))
  }
}

// post

interface PostFieldSetResponse {
  hrid: THrid
}

const postFieldSet = async (
  req: RestRequest,
  res: ResponseFunction,
  ctx: RestContext
) => {
  return addToEntityListData(req, res, ctx, getFieldSetListData)
}

const patchFieldSet = async (
  req: RestRequest,
  res: ResponseFunction,
  ctx: RestContext
) => {
  return updateEntityListData(req, res, ctx, getFieldSetListData)
}

const deleteFieldSet = async (
  req: RestRequest,
  res: ResponseFunction,
  ctx: RestContext
) => {
  return deleteEntityListData(req, res, ctx, getFieldSetListData)
}

export const handlers = [
  {
    method: 'get',
    path: '/api/fieldsets',
    handler: getList,
  },
  {
    method: 'get',
    path: '/api/fieldsets/:id/overview',
    handler: getFieldSetOverviewById,
  },
  {
    method: 'post',
    path: '/api/fieldsets',
    handler: postFieldSet,
  },
  {
    method: 'patch',
    path: '/api/fieldsets/:id',
    handler: patchFieldSet,
  },
  {
    method: 'delete',
    path: '/api/fieldsets/:id',
    handler: deleteFieldSet,
  },
  // delete many?
].map((h) => ({ ...h, ...{ handler: requireAuthenticatedUser(h.handler) } }))
